import { DEFAULT_ERROR_MESSAGE } from './constants';

const checkIsApiErrorHandler = (error: Error | CustomError): error is CustomError => {
  if ('response' in error) return true;
  return false;
};

class ApiErrorHandler extends Error {
  constructor(
    public error: CustomError | Error,
    msg?: string,
  ) {
    super(msg);
  }

  async getErrorData(): Promise<CustomApiErrorResponse> {
    if (checkIsApiErrorHandler(this.error)) {
      const data = await this.error.response.json();

      if (this.error.response.status === 401) {
        return {
          errorCode: data?.errorCode,
          reason: '인증되지 않은 유저입니다.\n로그인 후 다시 이용해주세요!',
        };
      }

      return {
        errorCode: data?.errorCode ?? 'UNKNOWN_ERROR',
        reason: data?.reason ?? DEFAULT_ERROR_MESSAGE.message,
      };
    }

    return {
      errorCode: 'UNKNOWN_ERROR',
      reason: DEFAULT_ERROR_MESSAGE.message,
    };
  }
}

export default ApiErrorHandler;
